import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../../../constants/breakpoints";
import { colors } from "../../../../../constants/colors";

const styles = createUseStyles({
  ticketsGrid: {
    margin: "24px 0 0 0",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: "24px -32px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: "24px -16px",
    },
    "& .rdt_TableRow": {
      "& >div:last-child": {
        position: "initial !important",
        right: "0px",
        backgroundColor: "inherit"
      }
    },
    "& .rdt_TableCell": {
      paddingLeft: "24px",
      paddingRight: "24px",
      minWidth: "155px",
      "& div": {
        color: colors.mediumGrey,
        fontWeight: "400",
        whiteSpace: "inherit !important"
      }
    },
    "& .rdt_TableCol": {
      paddingLeft: "24px",
      paddingRight: "24px",
      minWidth: "155px",
      whiteSpace: "nowrap"
    },
    "& .rdt_TableCell:last-child": {
      paddingRight: "24px"
    },
  },
  link: {
    textDecoration: "none",
    color: colors.grey
  },
  details: {
    "& p": {
      margin: 0,
      fontSize: "14px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    "& p:first-child": {
      color: colors.lightBlack,
      fontWeight: "500",
      lineHeight: "20px",
    },
    "& p:last-child": {
      color: colors.mediumGrey,
      fontWeight: "400",
      lineHeight: "20px",
    }
  },
});


export default styles;
